import React from "react";
import { useTranslation } from "react-i18next";
import CreateReleaseNotes from "./CreateReleaseNotes";

//components
import GridContainer from "components/UI/Grid/GridContainer";
import GridItemTS from "components/UI/Grid/GridItemTS";
import Card from "components/UI/Card/Card";
import CardBody from "components/UI/Card/CardBody";

import { TabContent, TabSystem } from "components/UI/TabSystem";
import { Box } from "@mui/material";

const ReleaseNotes: React.FC = () => {
  const { t } = useTranslation(["release-notes"]);

  const tabs = [
    {
      id: "new-release",
      title: t("new-release-note"),
    },
  ];

  return (
    <GridContainer>
      <GridItemTS xs={12}>
        <Card>
          <CardBody>
            <Box display="flex" flexDirection="column" margin={"1rem"}>
              <TabSystem tabs={tabs}>
                <TabContent value="new-release">
                  <CreateReleaseNotes />
                </TabContent>
              </TabSystem>
            </Box>
          </CardBody>
        </Card>
      </GridItemTS>
    </GridContainer>
  );
};

export default ReleaseNotes;
